// All imports and hint components removed since component now returns null

export const AnnotateHint = () => {
    // Hide the annotate hint from appearing
    return null;
};
